import { BuildOutlined } from "@ant-design/icons";
import { Button, message, InputNumber, Spin, Row, Col } from "antd";
import axios from "axios";
import React, { useState, useEffect } from "react";
import settingService from "../../../services/settingService";

const PROJECT_GITLAB_ID = "37021903";
const REF_NAME = "main";
const TOKEN = "glptt-64c810924820180a1ee3e681c33f4092df075fa7";

const PageManagement = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const [isLoading, setIsLoading] = useState(false);
  const [versionInfo, setVersionInfo] = useState({});
  useEffect(() => {
    handleLoadBuildInfo();
  }, []);

  const handleLoadBuildInfo = () => {
    setIsLoading(true);
    settingService
      .getSetting("build")
      .then((data) => {
        setIsLoading(false);
        console.log(data);
        setVersionInfo(data);
      })
      .catch((error) => {
        setIsLoading(false);
        messageApi.open({
          type: "error",
          content: error,
        });
      });
  };

  const onChange = (value) => {
    setVersionInfo({
      ...versionInfo,
      currentVersion: value,
    });
  };

  const handleBuild = () => {
    setIsLoading(true);
    axios
      .post(
        `https://gitlab.com/api/v4/projects/${PROJECT_GITLAB_ID}/ref/${REF_NAME}/trigger/pipeline?token=${TOKEN}`
      )
      .then((data) => {
        console.log(data);
        return settingService
          .updateSetting("build", {
            ...versionInfo,
            buildVersion: versionInfo.currentVersion,
          })
          .then(() => {
            setIsLoading(false);
            handleLoadBuildInfo();
            messageApi.open({
              type: "success",
              content:
                "The pipelines was Triggered, Please wait for 5 minutes!",
            });
          })
          .catch((error) => {
            setIsLoading(false);
            handleLoadBuildInfo();
            messageApi.open({
              type: "error",
              content: error,
            });
          });
      })
      .catch((errorgit) => {
        setIsLoading(false);
        messageApi.open({
          type: "error",
          content: errorgit,
        });
      });
  };
  return (
    <>
      {contextHolder}
      <Spin tip="Loading..." spinning={isLoading}>
        <Row>
          <Col span={2}>
            <b style={{ lineHeight: "36px" }}>Current Version </b>
          </Col>
          <Col span={2}>
            <InputNumber
              size="large"
              min={versionInfo?.buildVersion}
              value={versionInfo?.currentVersion}
              disabled={
                versionInfo?.buildVersion !== versionInfo?.currentVersion
              }
              onChange={onChange}
            />
          </Col>
          <Col span={6}>
            <Button
              type="primary"
              onClick={handleBuild}
              icon={<BuildOutlined />}
              size={"large"}
              disabled={
                versionInfo?.buildVersion === versionInfo?.currentVersion
              }
            >
              Trigger Build
            </Button>
          </Col>
        </Row>
      </Spin>
    </>
  );
};

export default PageManagement;
